import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccApplicationWithSortingScore } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { AdmissionsAreaService } from '../../../../admissions-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, domainData: DomainDataService, dialogService: DialogService, app: AppService, admissionsAreaService: AdmissionsAreaService): GridSetup<AccApplicationWithSortingScore> {

	return {
		rowName: { singular: 'Application', plural: 'Applications' },
		getRowKey: row => '' + row.accApplicationId,
		stateKey: 'prospects-all-applications',
		actions: getActions(dialogService, admissionsAreaService),
		buttons: [],
		columns: getColumns(util, domainData, app, admissionsAreaService),
	}
}
